import { render } from "./Kanban.vue?vue&type=template&id=6a9443c7&scoped=true"
import script from "./Kanban.vue?vue&type=script&lang=js"
export * from "./Kanban.vue?vue&type=script&lang=js"

import "./Kanban.vue?vue&type=style&index=0&id=6a9443c7&lang=scss&scoped=true"
import "./Kanban.vue?vue&type=style&index=1&id=6a9443c7&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9443c7"]])

export default __exports__